import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './ApptHistory.module.css'
import { PatientHomeAppt } from 'PatientCareCenter/Home/ApptHistory'
import { patientActions } from '_actions';
import { RadioButton, PdfButton, SortAsc, SortDesc, ScrollDiv } from '_components';
import { sortTimeOfDayHMMAA, sortDayOfWeek, getDateYYYYMMDD, formatYYYYMMDDtoMMDDYYYY } from '_helpers';

class PatientHomeApptHistory extends React.Component {

    renderDates() {
        if (this.props.selectedFilter === 'dates') {
            return (
                <span>
                    <label className={styles.date_label} htmlFor='start'>Start:</label>
                    <input
                        type='date'
                        id='start'
                        value={ getDateYYYYMMDD(this.props.startDate) }
                        onChange={event => this.props.changeStartDate({ ptno: this.props.ptno, startDate: formatYYYYMMDDtoMMDDYYYY(event.target.value) })}
                    />
                    <label className={styles.date_label} htmlFor='end'>End:</label>
                    <input
                        type='date'
                        id='end'
                        value={getDateYYYYMMDD(this.props.endDate)}
                        onChange={event => this.props.changeEndDate({ ptno: this.props.ptno, endDate: formatYYYYMMDDtoMMDDYYYY(event.target.value) })}
                    />
                </span>
            );
        } else {
            return (<span />);
        }
    }

    renderSortIcon(column) {
        var icon = this.props.sortOrder === 'asc' ? <SortAsc size='smaller' /> : <SortDesc size='smaller' />;
        return column === this.props.sortColumn ? icon : <span />;
    }


    render() {
        let oddEven = 0;
        return (
            <div className={styles.appt_wrapper}>
                <div className={styles.title}>Appointment History</div>
                <div className={styles.options}>
                    <div className={styles.spacer}></div>
                    <div className={styles.radios}>

                        <RadioButton
                            size='extra-small'
                            className={styles.radio}
                            label='Upcoming'
                            onClick={() => this.props.changeFilter({ ptno: this.props.ptno, filter: 'upcoming' })}
                            selected={this.props.selectedFilter === 'upcoming' ? true : false}
                        />
                        <RadioButton
                            size='extra-small'
                            className={styles.radio}
                            label='All Appointments'
                            onClick={() => this.props.changeFilter({ ptno: this.props.ptno, filter: 'all' })}
                            selected={this.props.selectedFilter === 'all' ? true : false}
                        />
                        <RadioButton
                            size='extra-small'
                            className={styles.radio}
                            label='Date Range'
                            onClick={() => this.props.changeFilter({ ptno: this.props.ptno, filter: 'dates' })}
                            selected={this.props.selectedFilter === 'dates' ? true : false}
                        />
                        {this.renderDates()}
                    </div>
                    <div className={styles.pdf}>
                        <PdfButton size='small' title='Appointment Report' className={styles.pdf_button} />
                    </div>
                </div>
                <div className={styles.appt_header}>
                    <div className={styles.spacer}></div>
                    <div className={styles.date} onClick={() => this.props.changeSort({ ptno: this.props.ptno, sortColumn: 'date' })}>
                        Date
                        {this.renderSortIcon('date')}
                    </div>
                    <div className={styles.time} onClick={() => this.props.changeSort({ ptno: this.props.ptno, sortColumn: 'time' })}>
                        Time
                        {this.renderSortIcon('time')}
                    </div>
                    <div className={styles.day} onClick={() => this.props.changeSort({ ptno: this.props.ptno, sortColumn: 'day' })}>
                        Day
                        {this.renderSortIcon('day')}
                    </div>
                    <div className={styles.type} onClick={() => this.props.changeSort({ ptno: this.props.ptno, sortColumn: 'type' })}>
                        Visit Type
                        {this.renderSortIcon('type')}
                    </div>
                    <div className={styles.status} onClick={() => this.props.changeSort({ ptno: this.props.ptno, sortColumn: 'status' })}>
                        Status
                        {this.renderSortIcon('status')}
                    </div>
                    <div className={styles.location} onClick={() => this.props.changeSort({ ptno: this.props.ptno, sortColumn: 'location' })}>
                        Clinic
                        {this.renderSortIcon('location')}
                    </div>
                </div>
                <ScrollDiv divId={this.props.ptno + '_PCC_HOME_APPTHIST'} className={styles.appt_body}>
                    {Object.keys(this.props.appts).length === 0 &&
                        <span className={styles.no_entries}>No Appointments.</span>
                    }
                    {Object.keys(this.props.appts)
                        .map(id => {
                            const appt = this.props.appts[id];
                            return (
                                <span key={appt.id} className={styles.appt_entry} style={{ backgroundColor: (oddEven++ % 2) === 0 ? '#e6f9ff' : 'transparent' }}>
                                    <PatientHomeAppt id={appt.id} />
                                </span>
                            )
                        })
                    }
                </ScrollDiv>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeFilter: bindActionCreators(patientActions.changeApptHistFilter, dispatch),
        changeStartDate: bindActionCreators(patientActions.changeApptHistStartDate, dispatch),
        changeEndDate: bindActionCreators(patientActions.changeApptHistEndDate, dispatch),
        changeSort: bindActionCreators(patientActions.changeApptHistSort, dispatch)
    };
}


function mapStateToProps(state) {
    let sortMultiplier = state.ui.apptHist[state.ui.patients.selectedPtno].sortOrder === 'asc' ? 1 : -1;
    let sortOrder = state.ui.apptHist[state.ui.patients.selectedPtno].sortOrder;
    return {
        ptno: state.ui.patients.selectedPtno,
        selectedFilter: state.ui.apptHist[state.ui.patients.selectedPtno].filter,
        startDate: state.ui.apptHist[state.ui.patients.selectedPtno].startDate,
        endDate: state.ui.apptHist[state.ui.patients.selectedPtno].endDate,
        sortOrder: state.ui.apptHist[state.ui.patients.selectedPtno].sortOrder,
        sortColumn: state.ui.apptHist[state.ui.patients.selectedPtno].sortColumn,
        appts: Object.keys(state.entities.apptHist)
            .filter(key => {
                var retval = false;

                switch (state.ui.apptHist[state.ui.patients.selectedPtno].filter) {
                    case 'upcoming':
                        if (state.entities.apptHist[key].ptno === state.ui.patients.selectedPtno &&
                            new Date(state.entities.apptHist[key].date).getTime() >= new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime()) {
                            retval = true;
                        }
                        break;
                    case 'all':
                        retval = state.entities.apptHist[key].ptno === state.ui.patients.selectedPtno;
                        break;
                    case 'dates':
                        if (state.entities.apptHist[key].ptno === state.ui.patients.selectedPtno &&
                            new Date(state.entities.apptHist[key].date).getTime() >= new Date(state.ui.apptHist[state.ui.patients.selectedPtno].startDate).getTime() &&
                            new Date(state.entities.apptHist[key].date).getTime() <= new Date(state.ui.apptHist[state.ui.patients.selectedPtno].endDate).getTime()) {
                            retval = true;
                        }
                        break;
                    default:
                        retval = state.entities.apptHist[key].ptno === state.ui.patients.selectedPtno;
                        break;
                }
                return retval;
            })
            .sort((a, b) => {
                switch (state.ui.apptHist[state.ui.patients.selectedPtno].sortColumn) {
                    case 'date':
                        return new Date(state.entities.apptHist[a].date).getTime() > new Date(state.entities.apptHist[b].date).getTime() ? sortMultiplier : -1 * sortMultiplier;
                    case 'time':
                        return sortTimeOfDayHMMAA(state.entities.apptHist[a].time, state.entities.apptHist[b].time, sortOrder);
                    case 'day':
                        return sortDayOfWeek(state.entities.apptHist[a].day, state.entities.apptHist[b].day, sortOrder);
                    case 'type':
                        return state.entities.apptHist[a].type > state.entities.apptHist[b].type ? sortMultiplier : -1 * sortMultiplier;
                    case 'status':
                        return state.entities.apptHist[a].status > state.entities.apptHist[b].status ? sortMultiplier : -1 * sortMultiplier;
                    case 'location':
                        return state.entities.apptHist[a].location > state.entities.apptHist[b].location ? sortMultiplier : -1 * sortMultiplier;
                    default:
                        return new Date(state.entities.apptHist[a].date).getTime() > new Date(state.entities.apptHist[b].date).getTime() ? sortMultiplier : -1 * sortMultiplier;
                }
            })
            .map(key => state.entities.apptHist[key])
    };
}

const connectedPatientHomeApptHistory = connect(mapStateToProps, mapDispatchToProps)(PatientHomeApptHistory);
export { connectedPatientHomeApptHistory as PatientHomeApptHistory };